import { useEffect, useRef, useState, type ReactNode } from 'react';

/** Kopfzeile einer Seite. Immer gleich aufgebaut, damit man sich auskennt. */
export function Kopf({
  titel, weg, rechts,
}: { titel: string; weg?: ReactNode; rechts?: ReactNode }) {
  return (
    /* TITEL UND WEG SIND EIN BLOCK, DIE WERKZEUGE SIND EINER.
       ======================================================================
       ORIGINALTEXT MARVIN (06.09.2026)
         „oben der kopf mit den wochewechsel, vorlaufzeit und firma ist nicht
          dynamisch genug, du siehst er macht einfach stumpf zwei spalten, das
          muss nicht sein, prüfe das auch bei den anderen seiten."

       Hier standen Überschrift, Weg und Werkzeugleiste als DREI Kinder
       derselben Flexzeile. Wird es eng, bricht das UMBRUCHFÄHIGSTE zuerst -
       und das war die Werkzeugleiste: nachgemessen bei 1180 Bildpunkten stand
       der Wochenwechsel in zwei Reihen und der Kopf war 112 statt 66
       Bildpunkte hoch.

       WAS BRECHEN DARF, IST DER TEXT UND NICHT DIE BEDIENUNG. Titel und Weg
       stehen jetzt in EINEM Block, der schrumpfen und umbrechen darf; die
       Werkzeuge bleiben eine Zeile. Zwei Zeilen Text unter einer Überschrift
       liest man; ein Knopf, der in die zweite Reihe rutscht, verschiebt jeden
       anderen mit. */
    <div className="kopf">
      <div className="kopftitel">
        <h1>{titel}</h1>
        {weg && <span className="weg">{weg}</span>}
      </div>
      <div className="wachsen" />
      {rechts}
    </div>
  );
}

/* HIER STAND DAS BAUTEIL „Baustelle", UND ES IST MIT MIGRATION 102 GEFALLEN.
 *
 * Es zeichnete oben auf einer Seite einen Hinweis, was dort noch nicht geht -
 * gespeist aus `modul.stand`, `kann`, `fehlt` und `ersetzt`. Das war die
 * Fortschrittsanzeige des Umbaus, und der ist am 28.08.2026 abgeschlossen:
 * seither stehen alle Module auf „fertig", und das Bauteil hat bei „fertig"
 * `null` zurückgegeben. Zehn Aufrufstellen, die nichts zeichnen.
 *
 * Weg musste es aus einem zweiten Grund, und der wiegt schwerer: `ersetzt`
 * trug den Satz, was an dieser Stelle in der Vorgängeranwendung stand („der
 * Upload-Ordner der alten Ablage", „die Gemeindeliste"). Wer das
 * liest, sucht danach.
 *
 *   ORIGINALTEXT MARVIN (02.09.2026)
 *     „diese plattform ist autark und völlig losgelöst von der anderen
 *      anwendung."
 *
 * Der GEDANKE dahinter bleibt richtig und gehört aufgehoben: eine halbfertige
 * Seite ohne Hinweis ist eine Falle - man sucht einen Knopf, der nicht fehlt,
 * sondern noch nicht existiert. Wer wieder einen braucht, schreibt ihn hin,
 * wo er hingehört: an die Seite, die noch nicht fertig ist, und nicht in eine
 * Spalte, die jede Seite mitschleppt.
 */

/**
 * Eine Zahl mit ihrer Beschriftung.
 *
 * Mit `klick` wird sie ein Weg: EINE ZAHL OHNE WEG DAHINTER IST EINE
 * BEHAUPTUNG. Dann ist es wirklich ein `button` und kein `div` mit einem
 * Klickfänger: sonst erreicht die Tastatur sie nicht, und der Innendienst
 * arbeitet die Auswertung mit der Tabulatortaste durch.
 */
export function Kachel({
  wert, was, farbe, klick, titel,
}: {
  wert: ReactNode; was: string; farbe?: string;
  klick?: () => void; titel?: string;
}) {
  const inhalt = (
    <>
      <div className="wert" style={farbe ? { color: farbe } : undefined}>{wert}</div>
      <div className="was">{was}</div>
    </>
  );
  if (!klick) return <div className="kachel">{inhalt}</div>;
  return (
    <button type="button" className="kachel klickbar" onClick={klick}
            title={titel ?? 'Die Aufträge dahinter ansehen'}>
      {inhalt}
    </button>
  );
}

/* `id` MACHT AUS EINER KARTE EIN SPRUNGZIEL. Das Abschnittsband
   (`teile/Abschnittsband.tsx`) springt darauf und färbt seinen Chip ein,
   sobald man in dieser Karte steht; `scroll-margin-top` in `stil.css` sorgt
   dafür, dass sie dabei nicht unter den klebenden Leisten landet. Ohne
   Kennung ändert sich nichts. */
export function Karte({
  titel, rechts, children, id,
}: { titel?: string; rechts?: ReactNode; children: ReactNode; id?: string }) {
  return (
    <div className="karte" id={id}>
      {titel && (
        <h3>
          {titel}
          {rechts && <span style={{ float: 'right', textTransform: 'none', letterSpacing: 0 }}>{rechts}</span>}
        </h3>
      )}
      <div className="leib">{children}</div>
    </div>
  );
}

export function Leer({ text }: { text: string }) {
  return <p className="leise klein" style={{ margin: 0 }}>{text}</p>;
}

/**
 * Ein Klappmenü mit Werkzeugen.
 *
 * ORIGINALTEXT MARVIN (25.08.2026)
 *   „bringe oben das menü in eine bessere Darstellung."
 *
 * WAS VORHER DA STAND: elf gleich aussehende Knöpfe nebeneinander, die auf
 * jedem üblichen Bildschirm in zwei ausgefranste Zeilen umbrachen. Elf
 * gleichrangige Knöpfe sind keine Rangfolge, sondern eine Wand, und man liest
 * sie beim zehnten Mal nicht mehr, sondern sucht.
 *
 * JETZT DREI STELLEN STATT ELF, und sie sind nach der FRAGE geordnet, nicht
 * nach der Reihenfolge des Einbaus: was am Vorgang geschieht, was man am
 * Auftrag nachschlägt, und das Bearbeiten selbst.
 *
 * ES WIRD NICHTS VERSTECKT. Jeder Punkt steht unter einer Überschrift, die
 * sagt, was darin liegt; ein Menü, dessen Name die Frage nicht beantwortet,
 * wäre schlimmer als die Wand. Ein Menü ohne einen einzigen erlaubten Punkt
 * erscheint gar nicht: ein leeres Klappmenü sieht aus wie ein kaputtes.
 *
 * Kein `details`-Element: dessen Pfeil und Randverhalten unterscheiden sich
 * je Browser, und es schliesst nicht von selbst, wenn man daneben klickt.
 */
export function Klappmenue({
  titel, haupt, kinder, zahl,
}: { titel: string; haupt?: boolean; kinder: ReactNode[]; zahl?: number }) {
  const [offen, setOffen] = useState(false);
  const feld = useRef<HTMLDivElement>(null);
  const punkte = kinder.filter(Boolean);

  useEffect(() => {
    if (!offen) return;
    const zu = (e: MouseEvent) => {
      if (!feld.current?.contains(e.target as Node)) setOffen(false);
    };
    const taste = (e: KeyboardEvent) => { if (e.key === 'Escape') setOffen(false); };
    document.addEventListener('mousedown', zu);
    document.addEventListener('keydown', taste);
    return () => {
      document.removeEventListener('mousedown', zu);
      document.removeEventListener('keydown', taste);
    };
  }, [offen]);

  if (!punkte.length) return null;

  return (
    <div className="klappmenue" ref={feld}>
      <button className={'knopf' + (haupt ? ' haupt' : '')} style={zahl ? { position: 'relative' } : undefined}
              aria-expanded={offen} onClick={() => setOffen(!offen)}>
        {titel}
        <span className="pfeil" aria-hidden="true">{offen ? '▴' : '▾'}</span>
        {/* .496: ein Kreis mit Zahl am Menü, wenn darin etwas Neues wartet. */}
        {/* .502: die Ziffer in ihrem eigenen Kasten, sonst hängt die Mitte an der
            Schriftart (siehe `.glockenziffer` in stil.css). Marvin: „die 4 steht
            nicht mittig in dem Chip drinne." */}
        {!!zahl && <span className="glockenzahl" aria-label={`${zahl} neu`}><span className="glockenziffer">{zahl}</span></span>}
      </button>
      {offen && (
        <div className="klappliste" onClick={() => setOffen(false)}>
          {punkte}
        </div>
      )}
    </div>
  );
}
